import { useEffect, useState } from 'react'

export default function MusicConsentSheet({ onChoice }) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (localStorage.getItem('nq_music_muted') === null) {
      setVisible(true)
    }
  }, [])

  if (!visible) return null

  function handleChoice(wantsMusic) {
    setVisible(false)
    onChoice?.(wantsMusic)
  }

  return (
    <div className="fixed inset-0 z-[70] flex items-end justify-center xl:items-center">
      <div className="absolute inset-0 bg-black/60" />
      <div className="relative w-full max-w-sm animate-slide-up rounded-t-3xl bg-[#0B1220] px-5 pt-4 pb-[calc(1.5rem+env(safe-area-inset-bottom))] text-white shadow-2xl xl:rounded-3xl xl:pb-6">
        <div className="mb-5">
          <div className="mx-auto mb-4 h-1.5 w-16 rounded-full bg-white/15" />
          <div className="mb-3 text-center text-4xl">🎵</div>
          <h3 className="text-center text-lg font-semibold">Bakgrundsmusik</h3>
          <p className="mt-2 text-center text-sm leading-relaxed text-white/70">
            Vill du ha musik medan du spelar? Du kan alltid ändra det senare.
          </p>
        </div>
        <div className="space-y-3">
          <button
            type="button"
            onClick={() => handleChoice(true)}
            className="w-full rounded-2xl bg-indigo-500 py-3 text-sm font-semibold text-white transition hover:bg-indigo-600"
          >
            Ja, spela musik
          </button>
          <button
            type="button"
            onClick={() => handleChoice(false)}
            className="w-full rounded-2xl bg-white/10 py-3 text-sm font-semibold text-white/70 transition hover:bg-white/15"
          >
            Nej tack
          </button>
        </div>
      </div>
    </div>
  )
}
